import { useIsMissionModerator } from './useIsMissionModerator';
import { useIsSelfServicedPilot } from './useIsSelfServicedPilot';
import { UserType } from '../consts/userType';

export const useCurrentUserType = () => {
  const isModerator = useIsMissionModerator();
  const isSelfServiced = useIsSelfServicedPilot();

  if (isModerator === null || isSelfServiced === null) {
    return null;
  }

  if (isModerator) {
    return UserType.Moderator;
  }

  return isSelfServiced ? UserType.SelfServicedPilot : UserType.TaPilot;
};
